// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  name: 'development',
  urlCloudRunLogin: 'https://neodatausuarios2021desarrollo-1093039628861.us-central1.run.app',
  // urlCloudRunLogin: 'http://localhost:8080',
  urlCloudRunPpto: 'https://pu2021desarrollo-1093039628861.us-central1.run.app',
  // urlCloudRunPpto: 'https://pu2021desarrollonube.punubeplus.app',
  // urlCloudRunPpto: 'http://localhost:8080',
  urlCloudRunNET: 'https://pu2020servidordesarrollo-r2rc53phyq-uc.a.run.app',
  urlNodeJSAI: 'https://busquedaiaservidor-nodejs-1093039628861.us-central1.run.app',
  urlProyecto: 'https://punubeplusdesarrollo.web.app',
  // urlProyecto: 'http://localhost:4200',
  nomBocketOrgLogo: 'organizacion-desarrollo',
  nomBocketPI: 'pie-indirectos-desarrollo',
  nomBocketSC: 'sobrecosto-desarrollo',
  nomBocketCH: 'costos-horarios-desarrollo',
  nomBocketFASAR: 'fasar-desarrollo',
  nomBocketPpto: 'presupuestos-desarrollo',
  googleClientId: '1007219206522-pvpi6p9jg29eai6bjq9d2t2snrnpfk0l.apps.googleusercontent.com',
  microsoftClientId: '329402fb-2c37-474c-8158-9c5b27039207',
  socketUrl: 'https://punubeplusservidor-nodejs-desarrollo-1093039628861.us-central1.run.app/'
  // socketUrl: 'http://localhost:8080'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
